import { SubFsmBuilder } from "little-fsm"
import { WayPointSelectionFsmContext } from "./WayPointsSelectionFsmContext"
import { DropOffOrderLineItemDTO, InternationalStringDTO, PickUpOrderLineItemDTO, TripCustomizationDTO, TripDTO, WayPointOptionDTO } from "../../apiclient/ApiDtos"

export type WayPointSelectionFsmScheme = {
    context: WayPointSelectionFsmContext,
    substates: [
        'initial',
        'fetching_trip_details',
        'showing_trip_fetching_error',
        'showing_main_page',
        "entering_pickup_details",
        "entering_dropoff_details",

        'ordering_waypoints',
        'showing_waypoint_order_error',
        'back_navigation_confirming'
    ],
    events: {
        'back': {},
        'back_confirmed': {},
        'back_cancelled': {},
        "trip_details_fetching_requested": { tripId: string },
        "trip_details_already_reveived": {},
        "trip_details_received": { tripDetails: TripDTO },
        "fetching_trip_detils_failed": { errorMessage: InternationalStringDTO },

        //"pickup_options_requested": {},
        //"dropoff_options_requested": {},
        //"pickup_point_selected": {},
        //"dropoff_point_selected": {},

        "dropoff_line_items_changed": { lineItems: DropOffOrderLineItemDTO[] },
        "pickup_line_items_changed": { lineItems: PickUpOrderLineItemDTO[] },

        "pickup_line_item_entry_requested": {},
        "dropoff_line_item_entry_requested": {},

        //"dropoff_options_changed": { dropOffOptions: PickUpOrderLineItemDTO[] },
        "waypoint_order_requested": {},
        "waypoint_order_succeed": { tripCustomization: TripCustomizationDTO }
        "waypoint_order_failed": { errorMessage: InternationalStringDTO },
        "completed": {}
    }
}

// just simple identity function
const $I = (x) => x;

export function wayPointSelectionSubFsmBuilder(): SubFsmBuilder<WayPointSelectionFsmScheme> {
    let subBuilder = new SubFsmBuilder<WayPointSelectionFsmScheme>();


    subBuilder
        .entrySubstate("initial");

    subBuilder.substate("initial")
        .transition("back", "back_navigation_confirming", (c, e) => c)
        .transition('trip_details_fetching_requested', 'fetching_trip_details', (context, event) => {
            return context;
        })
        .transition('trip_details_already_reveived', 'showing_main_page', (context, event) => {
            return context;
        })

    subBuilder.substate("fetching_trip_details")
        .transition("back", "back_navigation_confirming", (c, e) => c)
        .transition('trip_details_received', 'showing_main_page', (context, event) => {
            return context.withTripDetails(event.tripDetails);
        })
        .transition('fetching_trip_detils_failed', 'showing_trip_fetching_error', (context, event) => {
            return context.withErrorMessage(event.errorMessage);
        })

    subBuilder.substate("showing_trip_fetching_error")
        .transition("back", "back_navigation_confirming", (c, e) => c)

    subBuilder.substate("showing_main_page")
        .transition('pickup_line_item_entry_requested', 'entering_pickup_details', (context, event) => {
            return context;
        })
        .transition('dropoff_line_item_entry_requested', 'entering_dropoff_details', (context, event) => {
            return context;
        })
        .transition('pickup_line_items_changed', 'showing_main_page', (context, event) => {
            return context.withSelectedPickUpOptions(event.lineItems);
        })
        .transition('dropoff_line_items_changed', 'showing_main_page', (context, event) => {
            return context.withDropOffOptions(event.lineItems);
        })
        .transition('waypoint_order_requested', 'ordering_waypoints', (context, event) => {
            return context;
        })
        .completion('completed', (context, event) => {
            return context;
        })
        .transition("back", "back_navigation_confirming", (c, e) => c)

    subBuilder.substate("entering_pickup_details")
        .transition('pickup_line_items_changed', 'showing_main_page', (context, event) => {
            return context.withSelectedPickUpOptions(event.lineItems);
        })
        .transition('back', 'showing_main_page', (context, event) => {
            return context;
        })

    subBuilder.substate("entering_dropoff_details")
        .transition('dropoff_line_items_changed', 'showing_main_page', (context, event) => {
            return context.withDropOffOptions(event.lineItems);
        })
        .transition('back', 'showing_main_page', (context, event) => {
            return context;
        })

    subBuilder.substate("ordering_waypoints")
        .transition("back", "back_navigation_confirming", (c, e) => c)
        .transition('waypoint_order_failed', 'showing_waypoint_order_error', (context, event) => {
            return context.withErrorMessage(event.errorMessage);
        })
        .completion('waypoint_order_succeed', (context, event) => {
            return context.withTripCustomization(event.tripCustomization);
        })

    subBuilder.substate("showing_waypoint_order_error")
        .termination("back", $I)

    subBuilder.substate("back_navigation_confirming")
        .transition('back', 'initial', $I)
        .transition('back_cancelled', 'initial', $I)
        .termination('back_confirmed', $I)

    return subBuilder;
}

